<template>
  <div class="uk-position-relative">
    <div
        @click="showDateRangePiecker = !showDateRangePiecker"
        style="cursor: pointer;padding: 7px;"
        class="uk-position-cover">
      <md-icon>calendar_month</md-icon>
    </div>
    <input class="uk-input" style="padding-left: 40px;" type="text" :value="dateTimePeriod" disabled>
    <div v-if="showDateRangePiecker" class="md-datepicker-dialog tm-datepicker-dialog">
      <div class="uk-grid uk-grid-small uk-flex-middle" data-uk-grid data-uk-height-match="target: > div > *">
        <div class="uk-width-expand">
          <v-date-picker type="date"
                         name="choosenPeriod"
                         v-model="selectedPeriod"
                         firstDayOfWeek="1"
                         :range="true"
                         :max="todayDate"
                         @change="handleChange">

          </v-date-picker>
        </div>
        <div class="uk-width-auto">
          <button class="uk-button uk-button-success uk-height-1-1"
                  @click="showDateRangePiecker = !showDateRangePiecker"
                  style="color: #fff !important;">
            ok
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    dateTimePeriod: {
      type: String
    },
    choosenPeriod: {
      type: Array
    },
    getPeriod: {
      type: Function,
      required: true,
    },
    todayDate: {
      type: String
    }
  },

  data: () => ({
    showDateRangePiecker: false,
    selectedPeriod: null,
  }),

  methods: {
    handleChange() {
      this.getPeriod();
    },
  },

  watch: {
    selectedPeriod(newPeriod) {
      this.$emit('update:choosenPeriod', newPeriod);
    },
  },

}
</script>

